import { render } from "./OvCloseModal.vue?vue&type=template&id=403039e8&scoped=true"
import script from "./OvCloseModal.vue?vue&type=script&lang=js"
export * from "./OvCloseModal.vue?vue&type=script&lang=js"

import "./OvCloseModal.vue?vue&type=style&index=0&id=403039e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-403039e8"],['__file',"src/components/OvCloseModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "403039e8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('403039e8', __exports__)) {
    api.reload('403039e8', __exports__)
  }
  
  module.hot.accept("./OvCloseModal.vue?vue&type=template&id=403039e8&scoped=true", () => {
    api.rerender('403039e8', render)
  })

}


export default __exports__